<script setup lang="ts">
import type { HomepageResponse } from '@@/shared/homepage/type';
import src from '~/assets/images/homepage/reviews.jpg';

const props = withDefaults(defineProps<{
  reviews: HomepageResponse['reviews']
  variant?: 'default' | 'reviews'
}>(), {
  variant: 'default',
});

const { n } = useI18n();
const average = computed(() => {
  if (!props.reviews.average) return ``;
  return `${n(props.reviews.average)}/5`;
});
</script>

<template>
  <div>
    <IadWrapper v-if="variant === 'default'">
      <IadTitle
        :text="$t(`homepage.reviews.title`)"
        class="pb-s lg:pb-m"
        tag="h2"
        variant="large"
      />
    </IadWrapper>
    <HomeContentCard
      :src
      :alt="$t('homepage.agent_reviews.alt_text')"
    >
      <div>
        <Icon
          name="iad-icon:logo-immodvisor"
          class="w-[120px] md:w-[200px] h-auto"
          title="Logo Immodvisor"
        />
        <IadTitle
          :text="$t(`homepage.reviews.hook`)"
          variant="small-semibold"
          class="mt-2xs md:mt-xs"
          tag="p"
        />
        <div
          v-if="reviews.average"
          class="flex items-center gap-xs mt-m"
        >
          <IadTitle
            :text="average"
            variant="large"
            tag="p"
          />
          <IadRating
            :rating="reviews.average"
            size="x-large"
          />
        </div>
        <div class="mt-2xs md:mt-xs">
          <IadTitle
            :text="$t(`homepage.reviews.excellent`)"
            variant="small-semibold"
            tag="span"
          />
          {{ ` ` }}
          <IadTitle
            :text="$t(`homepage.reviews.based_on`, { count: $n(reviews.count ?? 0) })"
            variant="small"
            tag="span"
          />
        </div>
      </div>
      <template #action>
        <IadBtn
          v-if="variant === 'reviews'"
          size="large"
          variant="outlined"
          target="_blank"
          href="https://www.immodvisor.com/pro/iad-france-lieusaint-77127-15686.html"
          :text="$t(`homepage.reviews.cta`)"
        />
        <IadBtn
          v-else
          size="large"
          variant="outlined"
          :to="{ name: `reviews` }"
          :text="$t(`homepage.reviews.cta`)"
        />
      </template>
    </HomeContentCard>
  </div>
</template>
